import React from "react";

interface CsvPreviewTableProps {
  csvData: string[][];
}

export const CsvPreviewTable: React.FC<CsvPreviewTableProps> = ({ csvData }) => {
  if (!csvData.length) return null;
  return (
    <div className="max-h-[50vh] w-full max-w-full overflow-x-auto overflow-y-auto rounded border border-gray-200 bg-white">
      <table className="w-full min-w-max border-collapse text-sm">
        <thead>
          <tr className="bg-gray-100">
            {csvData[0].map((header, index) => (
              <th key={index} className="border border-gray-300 p-2 text-left font-semibold">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {csvData.slice(1).map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} className="border border-gray-300 p-2">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
